import { LanguageOption } from 'src/utils/languages';
import { QuestionData } from '../types';
import { stripUiOnlyFields } from './stripUiOnlyFields';
import { stripHtml } from './validation';
import { normalizeCountryCodes } from './normalizeCountryCodes';

export type FormCreationLastSavedSnapshot = {
  title: string;
  description: string;
  categoryName: string;
  categoryDescription: string;
  questions: QuestionData[];
  selectedLanguages: LanguageOption[];
  selectedCountryCodes: string[];
  autoReviewEnabled: boolean;
};

export function computeFormCreationHasUnsavedChanges(params: {
  isSpeakUpForm: boolean;
  categoryName: string;
  categoryDescription: string;
  title: string;
  description: string;
  strippedQuestions: string;
  selectedLanguages: LanguageOption[];
  selectedCountryCodes: string[];
  autoReviewEnabled: boolean;
  lastSaved: FormCreationLastSavedSnapshot;
}): boolean {
  const {
    isSpeakUpForm,
    categoryName,
    categoryDescription,
    title,
    description,
    strippedQuestions,
    selectedLanguages,
    selectedCountryCodes,
    autoReviewEnabled,
    lastSaved,
  } = params;

  const questionsChanged =
    strippedQuestions !==
    JSON.stringify(stripUiOnlyFields(lastSaved.questions));
  const languagesChanged =
    JSON.stringify(selectedLanguages) !==
    JSON.stringify(lastSaved.selectedLanguages);
  const countriesChanged =
    normalizeCountryCodes(selectedCountryCodes) !==
    normalizeCountryCodes(lastSaved.selectedCountryCodes);

  const commonChanges =
    title.trim() !== lastSaved.title ||
    stripHtml(description).trim() !== lastSaved.description ||
    categoryName.trim() !== lastSaved.categoryName ||
    stripHtml(categoryDescription).trim() !== lastSaved.categoryDescription ||
    questionsChanged ||
    languagesChanged;

  if (isSpeakUpForm) {
    return commonChanges;
  }

  return (
    commonChanges ||
    autoReviewEnabled !== lastSaved.autoReviewEnabled ||
    countriesChanged
  );
}
